<script>
import { Bar, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins
export default {
  extends: Bar,

  mixins: [ reactiveProp ],

  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: () => ({
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }],
            xAxes: [ {
              gridLines: {
                display: true
              }
            }]
          },
          legend: {
            display: false
          },
          responsive: true,
          maintainAspectRatio: false
        })
    },
  },

  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>